import { t } from "@bookingcom/lingojs-core";
import { INFANT_MAX_AGE } from "@flights/constants";
export const getPassengerByTravellerReference = (travellerRef, passengers) => {
    return passengers.find(({ travellerReference }) => travellerReference === travellerRef);
};
const getPassengerNumIndex = (travellerRef, passengers) => {
    const index = passengers.findIndex(({ travellerReference }) => travellerReference === travellerRef);
    return index >= 0 ? index + 1 : undefined;
};
export const getPassengerFullNameOrAnonymousTitle = (i18n, passenger, passengersList) => {
    const { travellerReference } = passenger;
    const numIndex = getPassengerNumIndex(travellerReference, passengersList);
    return isAnonymousPassenger(passenger)
        ? getPassengerAnonymousTitle(i18n, passenger, numIndex)
        : getPassengerFullName(i18n, passenger);
};
export const getPassengerAnonymousTitle = (i18n, passenger, numIndex, useNewCopy, typeNumIndex) => {
    const { type, age } = passenger;
    const strIndex = typeof numIndex === "number" ? numIndex : "";
    if (type === "ADULT") {
        return useNewCopy
            ? i18n.trans(t("flights_mdot_pax_overview_multi_adult", { variables: { adult_num: typeNumIndex || 1 } }))
            : i18n.trans(t("flights_book_process_travellernum_adult", {
                variables: {
                    num_traveller: strIndex
                }
            }));
    }
    else if (useNewCopy && type === "KID" && age !== undefined && age <= INFANT_MAX_AGE) {
        return i18n.trans(t("flights_mdot_pax_overview_multi_infant", { variables: { infant_num: typeNumIndex || 1 } }));
    }
    else if (type === "KID") {
        return useNewCopy
            ? i18n.trans(t("flights_mdot_pax_overview_multi_child", { variables: { child_num: typeNumIndex || 1 } }))
            : i18n.trans(t("flights_book_process_travellernum_child", {
                variables: { num_traveller: strIndex, num_age: String(age) },
                num_exception: age
            }));
    }
    else {
        return "";
    }
};
export const getPassengerFullName = (i18n, passenger) => {
    const { firstName, lastName } = passenger;
    return i18n.trans(t("flights_traveller_full_name", {
        variables: { first_name: firstName, last_name: lastName }
    }));
};
export const getPassengerFullNameByReference = (i18n, travellerReference, passengers) => {
    const passenger = getPassengerByTravellerReference(travellerReference, passengers);
    return passenger ? getPassengerFullName(i18n, passenger) : "";
};
export const getFullPassengerByShortTravellerReference = (travellerReference, passengers) => {
    const zeroBasedIndex = Number(travellerReference) - 1;
    return passengers[zeroBasedIndex];
};
export const isPassengerEligibleForBrazilianCpf = (travellerRequirements) => {
    return Boolean(travellerRequirements?.some((d) => d.includes("PASSPORT")) &&
        travellerRequirements?.includes("BRAZILIAN_CPF_NUMBER"));
};
export const numberOfInfantsOnFlight = (travellers) => {
    return travellers.filter((traveller) => isInfant(traveller)).length;
};
export const doesFlightHaveInfants = (travellers) => {
    return Boolean(travellers.some((traveller) => isInfant(traveller)));
};
export const isInfant = (traveller) => {
    const { age } = traveller;
    return typeof age === "number" && age <= INFANT_MAX_AGE;
};
const isAnonymousPassenger = (passenger) => {
    const { firstName, lastName } = passenger;
    return !firstName && !lastName;
};
export const getPassengerFrequentFlyerCard = (passenger) => {
    return passenger?.frequentFlyerCards?.[0];
};
